<template>
    <div class="c-middle" style="padding: 12px">
        <div class="c-middle-map">
            <div class="c-middle-grid-name">{{ gridInfo.name }}</div>
            <MapContainer ref="map" :showZoomTool="false" :showBottom="false" :center="mapConfig.positionVal"
                :zoom="mapZoom" :maxZoom="20" :minZoom="14">
                <template slot="openlayer">
                    <OpenlayerGridLayer :gridList="gridList" :gridWaypointList="gridInfo.gridWaypointList"
                        :gridId="(gridInfo.id).toString()" :photoInfo="photoInfo"
                        :positionFitVal="mapConfig.positionFitVal" :eventList="eventList" :eventInfoId="eventInfoId"
                        @GridImgRight="GridImgRight" :queryDate="selectTime"></OpenlayerGridLayer>
                </template>
            </MapContainer>
            <!-- 底部时间轴 -->
            <SelectYear v-if="selectYearShow" style="bottom: 40px" :selectTime="selectTime"
                @changeSelectTime="bindSelectTime">
            </SelectYear>
        </div>
        <div class="c-middle-right" :style="photoShow ? 'flex: 1.7;' : ' display: none;'">
            <div class="img-centre-bottom" :class="imgModel === '1' ? 'center-1' : 'center-2'"
                @click="photoShow = false">
                {{ $t('chengguan.dailypatrol.closeAlbum') }}
            </div>
            <div class="img-centre-top" :class="imgModel === '1' ? 'width-25' : 'width-100'">
                <div :class="imgModel === '1' ? 'activity-model' : ''" @click="changeModel('1')">
                    <i class="iconfont icon-tupianmoshi"></i> {{ $t('chengguan.dailypatrol.albumMode') }}
                </div>
                &nbsp;&nbsp;&nbsp;|
                <div :class="imgModel === '2' ? 'activity-model' : (historyImgList.length == 1 ? 'link-disabled' : '')"
                    @click="changeModel('2')">
                    <i class="iconfont icon-biduimoshi"></i> {{ $t('chengguan.dailypatrol.comparisonMode') }}
                </div>
                &nbsp;&nbsp;&nbsp;|
                <div :class="imgModel === '3' ? 'activity-model' : (historyImgList.length == 1 ? 'link-disabled' : '')"
                    @click="changeModel('3')">
                    <i class="iconfont icon-juanlianmoshi"></i> {{ $t('chengguan.dailypatrol.shutterMode') }}
                </div>
            </div>
            <template>
                <History class="right-item" v-if="imgModel === '1'" :historyImgList="historyImgList"></History>
                <Contrast class="right-item" v-if="imgModel === '2'" :historyImgList="historyImgList"></Contrast>
                <Curtain class="right-item" v-if="imgModel === '3'" :historyImgList="historyImgList"></Curtain>
            </template>
        </div>
    </div>
</template>

<script>
import { disable } from 'ol/rotationconstraint.js';
import DateUtil from '@/utils/DateUtil.js';
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import OpenlayerGridLayer from '@/page/business/chengguan/components/OpenlayerGridLayer/OpenlayerGridLayer.vue';
import { getHistoryFlightImages, getLatestFlightImages } from '../api/grid.js';
import api from '@/page/DataMessage/api';
import History from './History.vue';
import Contrast from './Contrast.vue';
import Curtain from './Curtain.vue';
import SelectYear from '@/page/business/components/SelectYear/SelectYear.vue';

export default {
    components: {
        MapContainer,
        SelectYear,
        OpenlayerGridLayer,
        History,
        Contrast,
        Curtain,
    },
    props: {
        eventInfoId: {
            type: String,
            default: '',
        },
        // 时间范围数组
        queryDate: {
            // eslint-disable-next-line no-bitwise
            type: Array,

            default () {
                return [];
            },
        },
        // 网格数据
        gridList: {
            type: Array,
            default () {
                return [];
            },
        },
        gridInfo: {
            type: Object,
            default () {
                return {};
            },
        },
        photoInfo: {
            type: Object,
            default: () => ({
                photoList: [],
            }),
        },
        // 事件列表数据
        eventList: {
            type: Array,
            default () {
                return [];
            },
        },
        mapConfig: {
            typeof: Object,
            default () {
                return {
                    positionFitVal: [],
                    positionVal: [],
                    mapRange: 0.0008,
                };
            },
        },
    },

    data () {
        // 计算当前日期的前一个月
        const getPrevMonth = () => {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // 当前月份（1-12）

            // 计算前一个月的年和月
            let prevYear;
            let prevMonth;
            if (currentMonth === 1) {
                // 若当前是1月，前一个月是去年12月
                prevYear = currentYear - 1;
                prevMonth = 12;
            } else {
                prevYear = currentYear;
                prevMonth = currentMonth - 1;
            }

            // 转换为selectLeftActiveMonth格式：(年份-2021)*12 + 月份

            return prevMonth;
        };
        return {
            mapZoom: 16,
            imgModel: '1',
            activityTab: '',
            routeObj: {}, // 路由对象，用于获取当前路由的参数
            photoShow: false,
            selectYearShow: true,

            // 历史图片列表数据
            historyImgList: [],
            gridWaypoint: '',
            searchForm: [],
            // 默认选中时间对象
            selectTime: {
                year: new Date().getFullYear(),
                yearLeft: new Date().getFullYear(),
                yearRight: new Date().getFullYear(),
                monthLeft: getPrevMonth(), // 默认今年1月
                monthRight: new Date().getMonth() + 1,
                dayLeft: new Date().getDate(),
                dayRight: new Date().getDate(),
            },

        };
    },
    watch: {
        queryDate: {
            handler (newVal) {
                if (newVal) {
                    this.selectTime = newVal;
                }
            },
            immediate: true,
            deep: true,
        },
        photoShow: {
            handler (newVal) {
                let mapRange = newVal ? 0.002 : 0.0008;
                let geometryText = this.gridInfo.geometryText;
                this.$emit('getPositionFitVal', geometryText, mapRange);
                this.selectYearShow = false;
                setTimeout(() => {
                    this.selectYearShow = true;
                }, 300);
            },
            deep: true,
        },
        imgModel: {
            handler (newVal) {
                if (newVal !== '1') {
                    this.searchForm = [];
                }
            },
            immediate: true,
            deep: true,
        },
        searchForm: {
            handler (newVal) {
                this.$emit('changeSelectTime', newVal);
                this.gridWaypoint && this.getHistoryFlightImages();
            },
            deep: true,
        },
        photoInfo: {
            handler (newVal) {
            },
            immediate: true,
            deep: true,
        },
    },
    created () {

    },
    computed: {},
    mounted () { },
    methods: {

        // 定义同步函数：将timeDate数组解析并映射到selectTime
        convertTime (list) {
            // 校验输入格式
            if (!Array.isArray(list) || list.length !== 2) {
                console.error('输入必须是包含两个时间字符串的数组');
                return;
            }

            // 解析左侧时间（list[0]）
            const leftDate = new Date(list[0]);
            // 解析右侧时间（list[1]）
            const rightDate = new Date(list[1]);
            // 映射到selectTime结构（当前年份取左侧时间的年份，保持原有结构）
            // eslint-disable-next-line consistent-return
            return {
                year: leftDate.getFullYear(), // 主年份取左侧时间的年份（或按需调整为右侧）
                yearLeft: leftDate.getFullYear(),
                yearRight: rightDate.getFullYear(),
                monthLeft: leftDate.getMonth() + 1, // 直接使用解析的月份（1-12）
                monthRight: rightDate.getMonth() + 1,
                dayLeft: leftDate.getDate(),
                dayRight: rightDate.getDate(),
            };
        },
        // 时间选择回调函数
        bindSelectTime (type, time) {
            // console.log('bindSelectTime', type, time);

            if (type === 'year') {
                this.selectTime.year = time;
            }
            if (type === 'times') {
                Object.assign(this.selectTime, time.Lefttimes, time.Righttimes);
            }
            this.searchForm = [
                `${this.selectTime.yearLeft}-${this.selectTime.monthLeft}-${this.selectTime.dayLeft} 00:00:00`,
                `${this.selectTime.yearRight}-${this.selectTime.monthRight}-${this.selectTime.dayRight} 23:59:59`,
            ];
        },
        // 查询网格航点的历史图片列表
        async getHistoryFlightImages () {
            let params = {
                id: this.gridWaypoint,
            };
            if (this.searchForm.length > 0) {
                params = {
                    ...params,
                    starTime: this.searchForm[0],
                    endTime: this.searchForm[1],
                };
            }
            let ref = await getHistoryFlightImages(params);
            this.historyImgList = [];
            if (ref.code === 200) {
                if (ref.data.length > 0) {
                    let list = this.getImageList(ref.data, [], '');
                    this.historyImgList = list;
                }
            } else {
                this.$message.error(ref.msg);
            }
        },
        async loadNearbyImages (pictureObj) {
            this.historyImgList = [];
            // 查找附近的历史照片，返回不包含查询图片本身
            let ref = await api.getNearbyPictureList({ id: pictureObj.id, distance: 10 });
            let list = [];
            if (ref.code === 200) {
                if (ref.data.length > 0) {
                    list = ref.data;
                }
            } else {
                // this.$message.error(ref.msg);
            }

            let resultList = [];
            // 将当前图片加入
            resultList.push(pictureObj);
            list.forEach((item) => {
                resultList.push(item);
            });
            this.historyImgList = resultList;
        },
        GridImgRight (val) {
            this.photoShow = false;
            if (val) {
                this.gridWaypoint = val.obj.gridWaypoint;
                if (this.gridWaypoint) {
                    this.photoShow = true;
                    this.gridWaypoint && this.getHistoryFlightImages(this.gridWaypoint);
                } else {
                    // console.log('val=',val.obj.latitude,val.obj.longitude)
                    this.loadNearbyImages(val.obj);
                    this.photoShow = true;
                    // this.$message.error('网格航点ID为空！');
                }
            }
        },

        changeModel (type) {
            this.imgModel = type;
        },
        getImageList (arr, list, type) {
            arr.forEach((item) => {
                if (item.eventList && item.eventList.length > 0) {
                    this.getImageList(item.eventList, list, 'event');
                } else {
                    list.push(type === 'event' ? item : item.taskDataPictureVo);
                }
            });
            return list;
        },
    },
    provide () {
        return {
            selectTime: this.selectTime, // 可传递响应式数据
        };
    },
};
</script>

<style lang="scss" scoped>
.c-middle {
    width: 100%;
    height: 100%;
    display: flex;

    .c-middle-map {
        flex: 1;
        height: 100%;
        position: relative;

        .c-middle-grid-name {
            position: absolute;
            top: 10px;
            left: 50%;
            margin-left: -150px;

            width: 240px;
            height: 40px;
            line-height: 40px;
            background: rgba(0, 0, 0, 0.65);
            border-radius: 2px 2px 2px 2px;
            text-align: center;
            z-index: 9;
        }
    }

    .c-middle-right {
        height: 100%;
        margin-left: 8px;
        padding: 0px;
        position: relative;

        .img-centre-bottom {
            position: absolute;
            bottom: 60px;

            width: 90px;
            height: 34px;
            text-align: center;
            line-height: 30px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 304px 304px 304px 304px;
            z-index: 100;
        }

        .img-centre-top {
            height: 30px;
            line-height: 30px;
            background: rgba(7, 17, 80, 0.7);
            z-index: 99;
            display: flex;
            position: absolute;

            div {
                padding: 0 8px;
            }
        }

        .right-item {
            height: calc(100%);
            width: 100%;
        }
    }
}

.activity-model {
    color: #49f0fdff;
}

.link-disabled {
    color: gray;
    cursor: not-allowed;
    pointer-events: none;
}

.width-25 {
    width: calc(100% - 250px);
}

.width-100 {
    width: 100%;
}

.center-1 {
    left: 415px;
}

.center-2 {
    left: 50%;
    margin-left: -45px;
}
</style>
